import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins.js";
import addModule from './modelManCom/addModule';
import { addmodule, modulelist, moduledel, module_update } from '@/api/auth';
export default {
  name: "moduleManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      headBtnList1: [{
        name: '新增',
        type: 'primary',
        icon: 'ios-add',
        method: this.add
      }, {
        name: '刷新',
        icon: 'ios-refresh',
        type: 'primary',
        method: this.init
      }],
      tableData: [],
      columnsData: [{
        title: '模块',
        key: 'mod_name',
        align: 'center'
      }, {
        title: '说明',
        key: 'mod_desc',
        align: 'center'
      }, {
        title: '模块代码',
        key: 'code',
        align: 'center'
      }, {
        title: '状态',
        key: 'state',
        align: 'center',
        render: function render(h, _ref) {
          var row = _ref.row;

          if (row.state === 0 || row.state === 1) {
            var state = _this2.states.filter(function (item) {
              return item.value === row.state;
            });

            return h("span", state[0].label || '无');
          }
        }
      }, {
        title: '操作',
        key: 'explain',
        align: 'center',
        width: 150,
        render: function render(h, _ref2) {
          var row = _ref2.row;
          var but = h("div", [h("Button", {
            style: {
              marginRight: "3px",
              color: '#2d8cf0'
            },
            props: {
              size: "small",
              type: 'text'
            },
            on: {
              "click": function click() {
                _this2.editModule(row);
              }
            }
          }, "编辑"), h("Button", {
            style: {
              color: '#2d8cf0'
            },
            props: {
              size: "small",
              type: 'text'
            },
            on: {
              "click": function click() {
                _this2.delModule(row);
              }
            }
          }, "删除")]);
          return but;
        }
      }],
      tableLoading: false,
      tabletotallen: 0,
      showBtn: false,
      border: true,
      stripe: true,
      moduleShow: false,
      addBase: {
        mod_name: "",
        res_name: "",
        state: "",
        mod_desc: ""
      },
      reqBase: {
        page: 1
      },
      states: [{
        value: 0,
        label: "禁用"
      }, {
        value: 1,
        label: "启用"
      }],
      modalTitle: true,
      ruleValidate: {
        mod_name: [{
          required: true,
          message: '请输入模块名',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入模块代码',
          trigger: 'blur'
        }],
        mod_desc: [{
          required: true,
          message: '请输入说明',
          trigger: 'blur'
        }],
        state: [{
          required: true,
          type: 'number',
          message: '请选择状态',
          trigger: 'change'
        }]
      }
    };
  },
  components: {},
  computed: {},
  methods: {
    init: function init() {
      this.getPageSizeToStorage();
      this.getData();
    },
    getData: function getData() {
      var _this3 = this;

      //loading 加载
      this.tableLoading = true;
      var vm = this;
      var strcookie = this.$store.state.user.token; //;

      var params = _objectSpread({
        access_token: strcookie
      }, vm.reqBase),
          callbak = function callbak(res) {
        _this3.tableLoading = false;

        if (res.result === 0) {
          //this.$Message.success(`${res.handleModulecreate}`);
          vm.tableData = res.body.list || [];
          vm.tabletotallen = res.body.total;
        } else {
          vm.tableData = [];
          vm.tabletotallen = 0;
        }
      };

      modulelist(params).then(function (res) {
        callbak(res);
      });
    },
    pageonChange: function pageonChange(index) {
      this.reqBase.page = index;
      this.getData();
    },

    /**
     * 控制模态框显示隐藏
     * type 显示隐藏
     * handle true新增 false编辑
     * row 本条数据
     */
    add: function add() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var handle = arguments.length > 1 ? arguments[1] : undefined;
      var row = arguments.length > 2 ? arguments[2] : undefined;
      var vm = this;
      var config = {
        loading: true,
        width: 600,
        okText: '确定',
        cancelText: '取消',
        render: function render(h) {
          return h('div', [h('h3', "新增模块"), h(addModule, {
            ref: 'addModule',
            props: {
              edit: false,
              _vm: vm
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addModule;
          obj.formCheck().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              addmodule(_objectSpread({}, formModel)).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(vm.$t('添加成功！'));
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              }).catch(function (err) {
                _this.buttonLoading = false;
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },

    /**
     * 编辑
     * modalTitle true新增  false编辑
     */
    editInit: function editInit(row) {
      this.addBase = {
        mod_name: row.mod_name,
        res_name: row.res_name,
        state: row.state,
        mod_desc: row.mod_desc
      };
    },

    /**
     *修改模块
     * */
    editModule: function editModule(row) {
      var vm = this;
      var config = {
        loading: true,
        width: 600,
        okText: '确定',
        cancelText: '取消',
        render: function render(h) {
          return h('div', [h('h3', "修改模块"), h(addModule, {
            ref: 'addModule',
            props: {
              edit: true,
              _vm: vm,
              setData: row
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addModule;
          obj.formCheck().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              module_update(formModel).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(vm.$t('修改成功！'));
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              }).catch(function (err) {
                _this.buttonLoading = false;
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },

    /**
     * 删除
     */
    delModule: function delModule(row) {
      var _this4 = this;

      var _this = this,
          title = "删除模块";

      var config = {
        loading: true,
        title: title,
        width: 400,
        content: "<p>\u786E\u8BA4\u5220\u9664\u6A21\u5757<span style=\"color: #f60;\">".concat(row.mod_name, "</span>\uFF1F</p>"),
        onOk: function onOk() {
          var params = {
            id: row.id
          },
              callbak = function callbak(req) {
            if (req.result === 0) {
              _this4.$Message.success(vm.$t('删除成功！'));

              _this4.$Modal.remove();

              _this.getData();
            } else {
              _this4.buttonLoading = false;

              _this4.$Message.error(req.errorMsg);
            }
          };

          moduledel(params).then(function (res) {
            callbak(res);
          });
        }
      };
      this.$Modal.confirm(config);
    }
  },
  mounted: function mounted() {
    this.init();
  },
  created: function created() {}
};